import { apiRequest, ApiError } from '@/api/apiClient/base';
import type { User } from '@/api/types';

/** The acting identity, whether it is a clearable session, and its admin snapshot. */
export interface Identity {
  user: User;
  // True for a signed-in session user (a cookie the SPA can clear).
  session: boolean;
  // The session's admin snapshot, taken from the caller's Firebase claims at
  // sign-in. Authorization has no local role field, so admin-ness is read here.
  isAdmin: boolean;
}

/**
 * The acting identity. Returns null when the server reports no identity (404) —
 * that is the normal "not signed in" state, not an error. `session`/`isAdmin`
 * default to false when the server omits them.
 */
export async function getMe(): Promise<Identity | null> {
  try {
    const data = await apiRequest<{
      user: User;
      session?: boolean;
      isAdmin?: boolean;
    }>('/api/users/me');
    return {
      user: data.user,
      session: data.session ?? false,
      isAdmin: data.isAdmin ?? false,
    };
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) {
      return null;
    }
    throw e;
  }
}
